<template>
  <div class="chat-container">
    <h1>ChatGPT Integration</h1>
    <div class="messages">
      <div v-for="(message, index) in messages" :key="index" class="message">
        <strong>{{ message.role }}:</strong> {{ message.content }}
      </div>
    </div>
    <textarea v-model="userInput" placeholder="Type your message..."></textarea>
    <button @click="sendMessage">Send</button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      messages: [{ role: "system", content: "Welcome to ChatGPT!" }],
      userInput: "",
    };
  },
  methods: {
    async sendMessage() {
      if (this.userInput.trim() === "") return;

      // Add user's message to the chat
      this.messages.push({ role: "user", content: this.userInput });

      try {
        // Send the user's message to the Express server
        // const apiUrl = "http://localhost:5001/api/chat"
        const apiUrl = "http://chat.makelemonade.uk/api/chat";
        const response = await axios.post(apiUrl, {
          messages: this.messages,
        });

        // Add ChatGPT's response to the chat
        const assistantMessage = response.data.choices[0].message;
        this.messages.push({
          role: assistantMessage.role,
          content: assistantMessage.content,
        });
      } catch (error) {
        console.error("Error communicating with the server:", error);
      }

      // Clear the input field
      this.userInput = "";
    },
  },
};
</script>

<style></style>
